export default __webpack_public_path__ + "static/media/girls-bottom.1dd15b41.png";